import { Link } from "react-router-dom";

const CONTACT_EMAIL = "contact@sylva-invest.com";
const CONTACT_PHONE = "+33681481237";

const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="py-16 bg-forest text-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div>
            <Link to="/" className="font-serif text-2xl font-semibold text-white tracking-tight mb-6 block hover:text-gold transition-colors">
              Sylva Invest
            </Link>
            <p className="font-sans text-sm text-white/70 leading-relaxed">
              Recomposition de propriétés forestières morcelées par des transactions
              réglementées, le remembrement foncier et le conseil stratégique.
            </p>
          </div>

          <div>
            <h3 className="font-serif text-lg mb-4 text-gold">Liens Rapides</h3>
            <ul className="space-y-2 font-sans text-sm">
              <li>
                <Link to="/#services" className="text-white/70 hover:text-gold transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/#carbone" className="text-white/70 hover:text-gold transition-colors">
                  Carbone Forestier
                </Link>
              </li>
              <li>
                <Link to="/#approach" className="text-white/70 hover:text-gold transition-colors">
                  Notre Approche
                </Link>
              </li>
              <li>
                <Link to="/#about" className="text-white/70 hover:text-gold transition-colors">
                  À Propos
                </Link>
              </li>
              <li>
                <Link to="/#contact" className="text-white/70 hover:text-gold transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-serif text-lg mb-4 text-gold">Ressources</h3>
            <ul className="space-y-2 font-sans text-sm">
              <li>
                <Link to="/ressources" className="text-white/70 hover:text-gold transition-colors">
                  Tous les Guides
                </Link>
              </li>
              <li>
                <Link to="/remembrement-forestier" className="text-white/70 hover:text-gold transition-colors">
                  Remembrement Forestier
                </Link>
              </li>
              <li>
                <Link to="/vendre-parcelle-bois" className="text-white/70 hover:text-gold transition-colors">
                  Vendre une Parcelle
                </Link>
              </li>
              <li>
                <Link to="/morcellement-forestier" className="text-white/70 hover:text-gold transition-colors">
                  Morcellement Forestier
                </Link>
              </li>
              <li>
                <Link to="/transactions-forestieres" className="text-white/70 hover:text-gold transition-colors">
                  Transactions Forestières
                </Link>
              </li>
              <li>
                <Link to="/successions-forestieres" className="text-white/70 hover:text-gold transition-colors">
                  Successions Forestières
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-serif text-lg mb-4 text-gold">Contact</h3>
            <ul className="space-y-2 font-sans text-sm text-white/70">
              <li>
                <a href={`mailto:${CONTACT_EMAIL}`} className="hover:text-gold transition-colors">
                  {CONTACT_EMAIL}
                </a>
              </li>
              <li>
                <a href={`tel:${CONTACT_PHONE}`} className="hover:text-gold transition-colors">
                  {CONTACT_PHONE}
                </a>
              </li>
              <li>Charente / Nouvelle-Aquitaine</li>
              <li>France</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="font-sans text-xs text-white/50">
            © {new Date().getFullYear()} Sylva Invest. Tous droits réservés.
          </p>
          <p className="font-sans text-xs text-white/50 mt-2 md:mt-0">
            Activité Immobilière Réglementée (Carte T) · Conseil en Foncier Forestier
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
